export default {
  meta: {
    title: '销售月报',
    url: '/abside/month', // 埋点字段，上报归属的模块
    urlName: 'ab侧-销售月报', // 埋点字段，上报归属的模块
    logincallback: '/abside',
  }
};
